export interface VideoSelfingDTO {}

export class UuIdDTO {
  uuId: string;
}

export class OnfidoTokenDTO {
  createdDate: string;
  sdkToken: string;
  workFlowRunId: string;
  process: string;
  applicantId: string;
  participantsNumber: number;
  language: string;
}

export class VideoSelfingLandingDTO {
  process: VIDEOSELFING_STATE;
  createdDate: string;
  participantsNumber: number;
  language: string;
}

export class CheckDTO {
  check: boolean;
}

export enum VIDEOSELFING_STATE {
  APPROVED = 'APPROVED',
  NOTINIT = 'NOT_INIT',
  INPROCESS = 'IN_PROCESS',
  KO = 'KO',
  EXPIRED = 'EXPIRED',
  REVIEW = 'REVIEW',
  DECLINED = 'DECLINED',
  PROCESSING = 'PROCESSING',
  ABANDONED = 'ABANDONED',
  ERROR = 'ERROR',
  AWAITING_INPUT = 'AWAITING_INPUT',
}
